import { Device } from '@capacitor/device';
import { WDDeviceInfoStored } from 'shared/types';
import { EdgeToEdge } from '@capawesome/capacitor-android-edge-to-edge-support';
import { Capacitor, SystemBars, SystemBarsStyle } from '@capacitor/core';
import { getScaleFactor, TEXT_ZOOM_CSS_VAR } from 'theme/watchdutyTheme.utils';
import { saveData, LOCAL_STORAGE_KEY } from '../../state/localStorage';

/**
 * Android text zoom scales font-size but not `em` lengths, so expose it for
 * `withTextZoom()`. Reading once is enough: font scale changes recreate the activity.
 */
export const setTextZoomCssVar = (): void => {
  if (Capacitor.getPlatform() !== 'android') return;

  document.documentElement.style.setProperty(
    TEXT_ZOOM_CSS_VAR,
    String(getScaleFactor()),
  );
};

export const setDeviceInfo = async (): Promise<WDDeviceInfoStored> => {
  const [id, deviceInfo] = await Promise.all([
    Device.getId(),
    Device.getInfo(),
  ]);

  saveData(LOCAL_STORAGE_KEY.DEVICE_INFO, {
    ...deviceInfo,
    uuid: id.identifier,
  });

  return { ...deviceInfo, uuid: id.identifier };
};

export const setStatusBarStyle = (args: {
  bgColor: string;
  style: SystemBarsStyle;
}): void => {
  EdgeToEdge.setStatusBarColor({ color: args.bgColor });
  SystemBars.setStyle({ style: args.style });
};
